import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { BRAND } from "@/lib/data";
import { SocialLinks } from "@/components/site/SocialLinks";

const LINKS = [
  { label: "Mission", href: "#mission" },
  { label: "Gallery", href: "#gallery" },
  { label: "Live", href: "#live" },
  { label: "Impact", href: "#impact" },
  { label: "Volunteer", href: "#volunteer" },
  { label: "Contact", href: "#contact" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (href) => {
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 left-0 w-full z-[100] transition-colors duration-500 ${
        scrolled ? "bg-black/70 backdrop-blur-xl border-b border-white/5" : "bg-transparent"
      }`}
    >
      <div className="mx-auto max-w-[1400px] px-5 md:px-10 h-20 flex items-center justify-between">
        <a
          href="#top"
          data-testid="nav-logo"
          onClick={(e) => { e.preventDefault(); go("#top"); }}
          className="flex items-center gap-3 group"
        >
          <span className="font-display text-2xl leading-none tracking-tight">
            <span className="text-white">M</span>
            <span className="text-green glow-green">G</span>
          </span>
          <span className="label hidden sm:block group-hover:text-green transition-colors">
            {BRAND.name}
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-9">
          {LINKS.map((l) => (
            <button
              key={l.href}
              data-testid={`nav-${l.label.toLowerCase()}`}
              onClick={() => go(l.href)}
              className="font-sub text-sm text-zinc-300 hover:text-white link-underline"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-donate"
            onClick={() => go("#donate")}
            className="btn-fill border border-green text-green font-sub text-sm font-semibold px-6 py-2.5 rounded-full"
          >
            Donate
          </button>
        </nav>

        <button
          className="md:hidden text-white"
          data-testid="nav-menu-toggle"
          onClick={() => setOpen((o) => !o)}
          aria-label="Menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-black/95 backdrop-blur-xl border-t border-white/5 px-6 py-8 flex flex-col gap-6">
          {LINKS.map((l) => (
            <button
              key={l.href}
              data-testid={`nav-mobile-${l.label.toLowerCase()}`}
              onClick={() => go(l.href)}
              className="font-display text-3xl uppercase text-left text-white"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-mobile-donate"
            onClick={() => go("#donate")}
            className="bg-green text-black font-sub font-semibold text-lg px-6 py-3 rounded-full mt-2"
          >
            Donate now
          </button>
          <SocialLinks variant="icons" className="mt-4 gap-5" />
        </div>
      )}
    </header>
  );
};
